
if (!customElements.get("appointedd-widget")) {
    customElements.define(
      "appointedd-widget",
      class AppointeddWidget extends HTMLElement {
        constructor() {
          super();

          this.stores = stores;
          this.submit = this.querySelector("form");
          this.input = this.querySelector("input[type='text']");
          this.widget = this.querySelector(".appointedd-widget__container__widget");

          //set up listeners
          this.setupListeners();
        }

        setupListeners() {

            this.submit.addEventListener("submit", (e) => {
              e.preventDefault();
              let match = false;
              let compareTo = [this.input.value]; //convert to array so we're always comparing to an array since we use arrays when the zipcode matches a special case scenario where we compare to all zipcodes in that area

              //Special cases
              let missoulaZips = ["59801", "59802", "59803", "59806", "59807", "59808", "59812", "59804", "59820", "59825", "59823", "59722", "59725", "59821", "59826", "59827", "59828", "59829", "59831", "59832", "59833", "59834", "59840", "59846", "59847", "59858", "59859", "59860", "59864", "59865", "59866", "59868", "59870", "59872", "59875"];
              let ryeBrookZips = ["10573", "10580", "10528", "10543", "10538", "10530", "10523", "10801", "10803", "10804", "10805", "10583", "10603", "10604", "10605", "10606", "10577", "10550", "10552", "10553", "10707", "10708", "10709", "06830", "06831", "06807", "06870", "06878"];
              let bozemanZips = ["59715", "59717", "59718", "59719", "59771", "59772", "59714"];
              let arlingtonZips = ["38002", "38012", "38028", "38060"];
              
              if (missoulaZips.includes(this.input.value)){
                compareTo = missoulaZips;
              } else if (ryeBrookZips.includes(this.input.value)){
                compareTo = ryeBrookZips;
              } else if (bozemanZips.includes(this.input.value)) {
                compareTo = bozemanZips;
              } else if (arlingtonZips.includes(this.input.value)) {
                compareTo = arlingtonZips;
              }
              
              this.stores.forEach( (store) => {
                console.log(compareTo);
                if (compareTo.includes(store.zipcode.toString())) {
                  var node = document.createElement("div");  // Create a new list node
                  var html = `<p><b>${store.store_name}</b></br>`;
                  html = html + `${store.street_address} ${store.street_address_2 ? store.street_address_2 : ""}</br>`;
                  html = html + `${store.city}, ${store.state_acronym} ${store.zipcode}</br>`;
                  html = html + `<a href="${store.get_direction_link}">Get Directions</a></br>`
                  html = html + `${store.working_hours}</p></br></br>`;
                  html = html + `<p><b>Please call this location to book a party!</b></p></br>`;
                  html = html + `<a class="btn" href='tel:${store.phone_number}'>Call ${store.phone_number}</a>`;
                  node.innerHTML = html;
                  this.appendChild(node);
                  match = true;
                }
              })
              
              if (match == false ){
                Appointedd.renderWidget('Appointed-widget',{ 
                  widgetId: "6810a52f196efdbb67f0f8d4", 
                  enableLanguageSelector: false,
                  preFillData: {
                    locationSearch: `${this.input.value} United States`
                  } 
                }); 

                this.widget.classList.add("__reveal");
              }

              return false;
               
            })
        }
    })
}